import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import projects from '../../redux/modules/projects';
import { apiUrls } from '../../constants/apiurls';
import { ProjectWorkspaceHeader } from '../../components/projectWorkspace/ProjectWorkspaceHeader';
import styles from '../../components/projectWorkspace/projectWorkspace.module.scss';

const projectListApi = projects.list();

export const CandidatesContainer = () => {
  const { projectId } = useParams();
  const { data } = projectListApi.useProjectlistQuery(
    { params: { id: projectId }, extendedPath: apiUrls.getProject() },
    { skip: !projectId },
  );
  return (
    <div className={`${styles.workspace} mainPanelRight`}>
      <ProjectWorkspaceHeader project={data?.data} />
      <Outlet />
    </div>
  );
};
